<template>
  <section>
    <el-dialog
      v-if="attachedForm.visible"
      :title="this.name"
      :visible.sync="attachedFormVisible"
      :close-on-click-modal="false"
      custom-class="customWidth"
      :before-close="closeBefore"
      center
    >
      <div style="padding: 12px">
        <abUploaderMulti
          style="margin-bottom: 12px"
          ref="hetongMultiRef"
          title="合同"
          accept="image/*,application/zip"
          @previewImage="previewImage"
        ></abUploaderMulti>
        <abUploaderMulti
          style="margin-bottom: 12px"
          ref="fapiaoMultiRef"
          title="发票"
          accept="image/*,application/zip"
          @previewImage="previewImage"
        ></abUploaderMulti>
        <abUploaderMulti
          style="margin-bottom: 12px"
          ref="baoguanMultiRef"
          title="报关单据"
          accept="image/*,application/zip"
          @previewImage="previewImage"
        ></abUploaderMulti>
        <abUploaderMulti
          style="margin-bottom: 12px"
          ref="wuliuMultiRef"
          title="物流单据"
          accept="image/*,application/zip"
          @previewImage="previewImage"
        ></abUploaderMulti>
        <abUploaderMulti
          style="margin-bottom: 12px"
          ref="otherMultiRef"
          title="其他"
          accept="image/*,application/zip"
          @previewImage="previewImage"
        ></abUploaderMulti>
      </div>

      <div slot="footer">
        <el-button
          type="primary"
          size="medium"
          :loading="loading"
          @click="declareComfirm()"
          >提交</el-button
        >
        <el-button size="medium" @click.native="attachedFormVisible = false"
          >取消</el-button
        >
      </div>
    </el-dialog>

    <el-image-viewer
      v-if="imageViewerVisible"
      style="z-index: 100000"
      :url-list="imgList"
      :on-close="() => (imageViewerVisible = false)"
      to="body"
    />
  </section>
</template>
<script>
import File from "@/utils/file";
import {
  queryMerVerifyFileList,
  attachedSubmit,
} from "@/api/crossborder/declare/restore/declare";
import compress from "@/utils/compress";
import imgSize from "@/utils/imgSize";
import abUploaderMulti from "@/components/abuploader/abUploaderMulti";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  name: "Attached",
  components: {
    abUploaderMulti,
    ElImageViewer,
  },
  data: function () {
    return {
      loading: false,
      attachedFormVisible: true,
      attachedForm: {
        visible: false,
        declareNo: "",
        merNo: "",
        contractUrl: "",
        invoiceUrl: "",
        customsDeclareUrl: "",
        logisticsUrl: "",
        otherUrl: "",
      },
      contractUrl: {
        title: "合同",
        imgKey: "contractUrl",
        hide: false,
        flagImg: false,
        url: "",
      },
      invoiceUrl: {
        title: "发票",
        imgKey: "invoiceUrl",
        hide: false,
        flagImg: false,
        url: "",
      },
      customsDeclareUrl: {
        title: "报关单据",
        imgKey: "customsDeclareUrl",
        hide: false,
        flagImg: false,
        url: "",
      },
      logisticsUrl: {
        title: "物流单据",
        imgKey: "logisticsUrl",
        hide: false,
        flagImg: false,
        url: "",
      },
      otherUrl: {
        title: "其它",
        imgKey: "otherUrl",
        hide: false,
        flagImg: false,
        url: "",
      },
      uploadArr: [],
      fileList: [],
      fileType: "",

      imageViewerVisible: false,
      imgList: [],
      previewIndex: 0,
    };
  },
  created() {},
  beforeMount() {
    this.name = "附件资料补充";
  },
  methods: {
    previewImage(url) {
      this.imgList = [url];
      this.previewIndex = 0;
      this.imageViewerVisible = true;
    },

    openAttached: function (index, row) {
      this.fileList = [];
      this.attachedForm.visible = true;
      this.attachedFormVisible = true;
      this.attachedForm.declareNo = row.declareNo;
      this.attachedForm.merNo = row.merNo;
      const param = {
        declareNo: this.attachedForm.declareNo,
      };
      queryMerVerifyFileList(param)
        .then((res) => {
          const list = res.data.fileList;

          let hetongArr = [];
          res.data.contractFiles.forEach((item) => {
            let item2 = {};
            if (item.remark && item.remark.includes("image")) {
              item2.previewUrl = item.previewUrl;
            } else {
              item2.previewUrl = "uploader_file_icon";
            }
            item2.realUrl = item.fileUrl;
            item2.type = "";
            item2.canDownload = false;
            item2.canRemove = false;
            item2.uploadSuccess = true;
            item2.downloading = false;
            hetongArr.push(item2);
          });
          this.$refs.hetongMultiRef.setImgArr(hetongArr);

          let fapiaoArr = [];
          res.data.invoiceFiles.forEach((item) => {
            let item2 = {};
            if (item.remark && item.remark.includes("image")) {
              item2.previewUrl = item.previewUrl;
            } else {
              item2.previewUrl = "uploader_file_icon";
            }
            item2.realUrl = item.fileUrl;
            item2.type = "";
            item2.canDownload = false;
            item2.canRemove = false;
            item2.uploadSuccess = true;
            item2.downloading = false;
            fapiaoArr.push(item2);
          });
          this.$refs.fapiaoMultiRef.setImgArr(fapiaoArr);

          let baoguanArr = [];
          res.data.declarationFiles.forEach((item) => {
            let item2 = {};
            if (item.remark && item.remark.includes("image")) {
              item2.previewUrl = item.previewUrl;
            } else {
              item2.previewUrl = "uploader_file_icon";
            }
            item2.realUrl = item.fileUrl;
            item2.type = "";
            item2.canDownload = false;
            item2.canRemove = false;
            item2.uploadSuccess = true;
            item2.downloading = false;
            baoguanArr.push(item2);
          });
          this.$refs.baoguanMultiRef.setImgArr(baoguanArr);

          let wuliuArr = [];
          res.data.logisticsFiles.forEach((item) => {
            let item2 = {};
            if (item.remark && item.remark.includes("image")) {
              item2.previewUrl = item.previewUrl;
            } else {
              item2.previewUrl = "uploader_file_icon";
            }
            item2.realUrl = item.fileUrl;
            item2.type = "";
            item2.canDownload = false;
            item2.canRemove = false;
            item2.uploadSuccess = true;
            item2.downloading = false;
            wuliuArr.push(item2);
          });
          this.$refs.wuliuMultiRef.setImgArr(wuliuArr);

          let otherArr = [];
          res.data.otherFiles.forEach((item) => {
            let item2 = {};
            if (item.remark && item.remark.includes("image")) {
              item2.previewUrl = item.previewUrl;
            } else {
              item2.previewUrl = "uploader_file_icon";
            }
            item2.realUrl = item.fileUrl;
            item2.type = "";
            item2.canDownload = false;
            item2.canRemove = false;
            item2.uploadSuccess = true;
            item2.downloading = false;
            otherArr.push(item2);
          });
          this.$refs.otherMultiRef.setImgArr(otherArr);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    declareComfirm() {
      // 获取上传相关数据
      let hetongArr = this.$refs.hetongMultiRef.getImgArr();
      let fapiaoArr = this.$refs.fapiaoMultiRef.getImgArr();
      let baoguanArr = this.$refs.baoguanMultiRef.getImgArr();
      let wuliuArr = this.$refs.wuliuMultiRef.getImgArr();
      let otherArr = this.$refs.otherMultiRef.getImgArr();

      let fileList = [];

      hetongArr.forEach((item) => {
        if (item.canRemove) {
          item.fileType = "03";
          item.imgKey = "contractUrl";
          item.declareNo = this.attachedForm.declareNo;
          item.merNo = this.attachedForm.merNo;
          item.fileProperty = "03";
          item.fileUrl = item.path;
          item.remark = item.type;
          fileList.push(item);
        }
      });
      fapiaoArr.forEach((item) => {
        if (item.canRemove) {
          item.fileType = "02";
          item.imgKey = "invoiceUrl";
          item.declareNo = this.attachedForm.declareNo;
          item.merNo = this.attachedForm.merNo;
          item.fileProperty = "02";
          item.fileUrl = item.path;
          item.remark = item.type;
          fileList.push(item);
        }
      });
      baoguanArr.forEach((item) => {
        if (item.canRemove) {
          item.fileType = "05";
          item.imgKey = "customsDeclareUrl";
          item.declareNo = this.attachedForm.declareNo;
          item.merNo = this.attachedForm.merNo;
          item.fileProperty = "05";
          item.fileUrl = item.path;
          item.remark = item.type;
          fileList.push(item);
        }
      });
      wuliuArr.forEach((item) => {
        if (item.canRemove) {
          item.fileType = "06";
          item.imgKey = "logisticsUrl";
          item.declareNo = this.attachedForm.declareNo;
          item.merNo = this.attachedForm.merNo;
          item.fileProperty = "06";
          item.fileUrl = item.path;
          item.remark = item.type;
          fileList.push(item);
        }
      });
      otherArr.forEach((item) => {
        if (item.canRemove) {
          item.fileType = "07";
          item.imgKey = "otherUrl";
          item.declareNo = this.attachedForm.declareNo;
          item.merNo = this.attachedForm.merNo;
          item.fileProperty = "07";
          item.fileUrl = item.path;
          item.remark = item.type;
          fileList.push(item);
        }
      });

      if (fileList.length === 0) {
        this.$message.error("请先上传文件");
        return;
      }

      // console.log('attachedSubmit:' + param)
      this.loading = true;
      attachedSubmit(fileList)
        .then((response) => {
          this.loading = false;
          // console.log(response.data)
          this.attachedForm.visible = false;
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.closeBefore();
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },

    closeBefore() {
      // 清空图片回显
      this.$refs.hetongMultiRef.setImgArr([]);
      this.$refs.fapiaoMultiRef.setImgArr([]);
      this.$refs.baoguanMultiRef.setImgArr([]);
      this.$refs.wuliuMultiRef.setImgArr([]);
      this.$refs.otherMultiRef.setImgArr([]);
      this.attachedForm.visible = false;
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/common.scss";
.show-img {
  width: 100%;
  max-width: 500px;
  height: 280px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

p {
  margin-bottom: 10px;
}
</style>
<style lang="scss">
.hide .el-upload--picture-card {
  display: none;
}
.customWidth {
  width: 60%;
}
.el-upload-list--picture-card .el-upload-list__item {
  margin: 0;
}
.el-upload__tip {
  margin-top: 0px;
}
</style>
